import { KIMI_K2_INSTRUCT_MODEL, QWEN3_32B_MODEL, GEMMA2_9B_IT_MODEL } from "./groq";
import { GPT_OSS_120B, QWEN3_235B } from "./baseten";
import { QWEN_IMAGE_MODEL } from "./replicate";
import { DALL_E_3 } from "./openai";

export type Model = {
  id: string;
  name: string;
  provider: string;
  isAdvanced: boolean;
};

/**
 * Available models configuration across all providers
 */
export const textModels: Model[] = [
  { id: GPT_OSS_120B, name: "GPT 120B", provider: "baseten", isAdvanced: false },
  { id: QWEN3_235B, name: "Qwen3-235B", provider: "baseten", isAdvanced: false },
  { id: GEMMA2_9B_IT_MODEL, name: "Gemma 2 9B", provider: "groq", isAdvanced: false },
  { id: QWEN3_32B_MODEL, name: "Qwen3-32B", provider: "groq", isAdvanced: false },
  { id: KIMI_K2_INSTRUCT_MODEL, name: "Kimi K2", provider: "groq", isAdvanced: true },
];

export const imageModels: Model[] = [
  { id: QWEN_IMAGE_MODEL, name: "Qwen Image", provider: "replicate", isAdvanced: true },
  { id: DALL_E_3, name: "DALL-E 3", provider: "openai", isAdvanced: true },
];

export const DEFAULT_TEXT_MODEL = textModels[0].id;
export const DEFAULT_IMAGE_MODEL = imageModels[0].id;

/**
 * Check if a model is an advanced model
 */
export const isAdvancedModel = (modelId: string): boolean => {
  const model = [...textModels, ...imageModels].find((m) => m.id === modelId);
  return model?.isAdvanced ?? false;
};
